/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiUsdkOtherChannelCallback } from '@/api/usdk';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'otherCallbackUrl',
  props: {
    gid: {
      type: [Number, String],
      required: true,
      default: 0
    }
  },
  emits: ['ok'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const url = ref('');
    const oldUrl = ref('');
    const cid = ref(0);
    const show = data => {
      cid.value = data.cid;
      url.value = data.url;
      oldUrl.value = data.url;
      dialogVisible.value = true;
    };
    const emits = __emit;
    const handleSubmit = () => {
      const dict = {
        url: {
          name: '渠道回调转发地址'
        }
      };
      if (!url.value) {
        ElMessage.error('请输入回调地址');
        return;
      }
      confirmLoading.value = true;
      apiUsdkOtherChannelCallback({
        gid: props.gid,
        cid: cid.value,
        otherCallbackUrl: url.value
      }).then(res => {
        if (res.code === 0) {
          handleClose();
          emits('ok');
          customDataReport({
            eventName: 'set_channel_callback_url',
            dict,
            before: {
              url: oldUrl.value
            },
            after: {
              url: url.value
            },
            operatePath: '运营-登录支付配置-支付和商品管理-渠道回调转发地址',
            gid: props.gid
          });
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "渠道回调转发地址",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "回调地址"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(url),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(url) ? url.value = $event : null),
              placeholder: "请输入渠道回调转发地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});